import {images} from '../../constants/image';

export const getStaticModalIconUrl = (iconVariant: string | undefined) => {
  const listIconUlrs = {
    alert: images.icon_cicle_warning,
    success: images.icon_cicle_success,
  };
  return iconVariant ? listIconUlrs[iconVariant] || null : null;
};
